import React from 'react'
import PropTypes from 'prop-types'
import { Text, utils } from '@adc/ui-adc'
const formatMoney = utils.formatters.formatMoney

const EarnestMoneyDeposit = ({ listing, earnestMoneyDeposit, hasError }) => {
  if (!listing.__methods__.isUsingSellerLevelFees()) {
    return null
  }
  return (
    <>
      <Text
        className='u-mr-1'
        color='gray'
        content='Earnest Money Deposit'
        data-elm-id='earnest_money_deposit_label'
        size='tiny'
      />
      <Text
        color='gray'
        content={hasError ? '–' : formatMoney(earnestMoneyDeposit)}
        data-elm-id='earnest_money_deposit_value'
        size='tiny'
        weight='heavy'
      />
    </>
  )
}

EarnestMoneyDeposit.propTypes = {
  listing: PropTypes.object.isRequired,
  earnestMoneyDeposit: PropTypes.number,
  hasError: PropTypes.bool,
}

export default EarnestMoneyDeposit
